import { render } from "./WorkAccident.vue?vue&type=template&id=7fea19be&scoped=true"
import script from "./WorkAccident.vue?vue&type=script&lang=js"
export * from "./WorkAccident.vue?vue&type=script&lang=js"

import "./WorkAccident.vue?vue&type=style&index=0&id=7fea19be&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fea19be"]])

export default __exports__